module.exports = __webpack_public_path__ + "img/icon-map-derek.bbf27687.svg";